<template>
    <main class="client-edit-page">
        <section class="client-edit-card">
            <header class="client-edit-header">
                <div class="client-edit-title">
                    <el-button class="client-back-button" icon="el-icon-arrow-left"
                               @click.native.prevent="goBack"></el-button>
                    <h1>{{$t('clientCreate.pageTitle')}}</h1>
                </div>
                <el-button class="client-save-button" type="primary" :disabled="buttonDisabledStatus"
                           @click.native.prevent="createClient">{{$t('common.save')}}</el-button>
            </header>

            <el-form class="client-modern-form" label-width="0px" :model="objectModel" :rules="validRules"
                     v-loading="loading" ref="objectModel">
                <section class="client-form-section">
                    <div class="client-section-header">
                        <div class="client-section-title">
                            <i class="el-icon-user client-section-icon"></i>
                            <span>{{$t('clientCreate.basicInformation')}}</span>
                        </div>
                    </div>
                    <div class="client-section-content">
                        <el-form-item class="client-form-row" prop="name">
                            <span class="client-form-label">{{$t('clientCreate.labelName')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.name"
                                      :placeholder="$t('clientCreate.placeholderName')"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row" prop="clientEmail">
                            <span class="client-form-label">{{$t('clientCreate.labelEmail')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.clientEmail"
                                      :placeholder="$t('clientCreate.placeholderEmail')"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelPhone')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.phone"
                                      :placeholder="$t('clientCreate.placeholderPhone')"></el-input>
                        </el-form-item>
                    </div>
                </section>

                <section class="client-form-section">
                    <div class="client-section-header">
                        <div class="client-section-title">
                            <i class="el-icon-document client-section-icon"></i>
                            <span>{{$t('clientCreate.billingAddress')}}</span>
                        </div>
                    </div>
                    <div class="client-section-content">
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelLine1')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.billingAddressLine1"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelLine2')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.billingAddressLine2"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelLine3')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.billingAddressLine3"></el-input>
                        </el-form-item>
                    </div>
                </section>

                <section class="client-form-section">
                    <div class="client-section-header">
                        <div class="client-section-title">
                            <i class="el-icon-location-outline client-section-icon"></i>
                            <span>{{$t('clientCreate.shippingAddress')}}</span>
                        </div>
                        <el-checkbox v-model="sameAsBilling" class="client-same-checkbox">{{$t('clientCreate.sameAsBilling')}}</el-checkbox>
                    </div>
                    <div class="client-section-content">
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelShippingName')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.shippingName"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelShippingLine1')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.shippingAddressLine1"
                                      :disabled="sameAsBilling"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelShippingLine2')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.shippingAddressLine2"
                                      :disabled="sameAsBilling"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelShippingLine3')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.shippingAddressLine3"
                                      :disabled="sameAsBilling"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row client-note-row">
                            <span class="client-form-label">{{$t('clientCreate.labelNotes')}}</span>
                            <el-input class="client-line-textarea" type="textarea" autosize v-model="objectModel.note"
                                      :placeholder="$t('clientCreate.placeholderNotes')"></el-input>
                        </el-form-item>
                    </div>
                </section>
            </el-form>
        </section>
    </main>
</template>

<script>
    import {uuid, timest, validateEmail} from '@/utils/validate'

    export default {
        data() {
            const validEmail = (rule, value, callback) => {
                if (value.length > 0 && !validateEmail(value)) {
                    callback(new Error(this.$t('clientCreate.validEmail')))
                } else {
                    callback()
                }
            }
            return {
                objectModel: {
                    name: '',
                    clientEmail: '',
                    phone: '',
                    billingAddressLine1: '',
                    billingAddressLine2: '',
                    billingAddressLine3: '',
                    shippingName: '',
                    shippingAddressLine1: '',
                    shippingAddressLine2: '',
                    shippingAddressLine3: '',
                    note: ''
                },
                sameAsBilling: false,
                loading: false,
                buttonDisabledStatus: false,
                validRules: {
                    clientEmail: [{trigger: ['blur', 'change'], validator: validEmail}],
                }
            }
        },
        watch: {
            sameAsBilling(value) {
                if (value) {
                    this.syncShippingAddress();
                }
            },
            'objectModel.billingAddressLine1'() {
                this.syncShippingAddressIfNeeded();
            },
            'objectModel.billingAddressLine2'() {
                this.syncShippingAddressIfNeeded();
            },
            'objectModel.billingAddressLine3'() {
                this.syncShippingAddressIfNeeded();
            }
        },
        methods: {
            syncShippingAddressIfNeeded() {
                if (this.sameAsBilling) {
                    this.syncShippingAddress();
                }
            },
            syncShippingAddress() {
                this.objectModel.shippingAddressLine1 = this.objectModel.billingAddressLine1;
                this.objectModel.shippingAddressLine2 = this.objectModel.billingAddressLine2;
                this.objectModel.shippingAddressLine3 = this.objectModel.billingAddressLine3;
            },
            goBack() {
                let self = this;
                self.$router.push('/client');
            },
            createClient() {
                let self = this;
                this.$refs.objectModel.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.buttonDisabledStatus = true;
                        this.$axios.post('create_user_client', {
                            params: {
                                name: this.objectModel.name,
                                clientEmail: this.objectModel.clientEmail,
                                phone: this.objectModel.phone,
                                billingAddressLine1: this.objectModel.billingAddressLine1,
                                billingAddressLine2: this.objectModel.billingAddressLine2,
                                billingAddressLine3: this.objectModel.billingAddressLine3,
                                shippingName: this.objectModel.shippingName,
                                shippingAddressLine1: this.objectModel.shippingAddressLine1,
                                shippingAddressLine2: this.objectModel.shippingAddressLine2,
                                shippingAddressLine3: this.objectModel.shippingAddressLine3,
                                note: this.objectModel.note,
                                innerUUID: uuid(null, 37),
                                createDate: timest(),
                                accessDate: timest(),
                                cell:"",
                                contact:"",
                                fax:"",
                                pager:"",
                                website:"",
                                itemDiscount: 0,
                                itemDiscountAsPercent: 0,
                                isDelete: 0,
                                syncStatus: 0
                            }
                        }).then(response => {
                            this.loading = false;
                            self.buttonDisabledStatus = false;
                            if (response.data.errorCode === 0) {
                                self.$router.push('/client');
                            }
                        }).catch(function () {
                            self.loading = false;
                            self.buttonDisabledStatus = false;
                        })
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>
